import { useEffect, useState } from "react";
import api from "../lib/api";
import { BookmarkCheck, Trash2, Loader2, NotebookPen } from "lucide-react";
import { toast } from "sonner";

export default function StudyNotes() {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/study-notes");
      setNotes(data.notes || []);
    } catch (e) {
      console.error("study notes load failed", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    setNotes((n) => n.filter((x) => x.id !== id));
    await api.delete(`/study-notes/${id}`).catch(() => toast.error("Could not remove note"));
  };

  const when = (iso) => {
    try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }); }
    catch { return ""; }
  };

  return (
    <div data-testid="study-notes-section">
      <div className="flex items-center gap-2 mb-4">
        <NotebookPen className="w-5 h-5 text-secondary" />
        <h2 className="font-heading font-bold text-lg">Study Notes</h2>
        <span className="text-sm text-muted-foreground">({notes.length})</span>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-muted-foreground text-sm"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
      ) : notes.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="study-notes-empty">
          Nothing saved yet. During a call, hit <span className="font-semibold">Save for Later</span> on any chat message to build your own review deck.
        </p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3" data-testid="study-notes-list">
          {notes.map((n) => (
            <div key={n.id} className="group relative rounded-2xl border border-border bg-card p-4" data-testid={`study-note-${n.id}`}>
              <div className="flex items-center gap-1.5 mb-1 text-[10px] uppercase tracking-widest font-bold text-muted-foreground">
                <BookmarkCheck className="w-3 h-3 text-secondary" /> {n.author_name || "Partner"} · {when(n.said_at || n.created_at)}
              </div>
              <p className="font-heading font-bold text-base leading-snug">{n.original}</p>
              {n.translation && <p className="text-sm text-muted-foreground mt-1 italic">{n.translation}</p>}
              <button
                onClick={() => remove(n.id)}
                data-testid={`study-note-delete-${n.id}`}
                title="Remove"
                className="absolute top-2.5 right-2.5 opacity-0 group-hover:opacity-100 transition-opacity text-muted-foreground hover:text-destructive"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
